import {
  API_FAILURE_NOTIFICATION,
} from './constants'

export function triggerGlobalApiFailureNotification () {
  return (dispatch) => {
    return dispatch({
      type: API_FAILURE_NOTIFICATION,
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/notifications/actions.js